module.exports = __webpack_public_path__ + "img/icon-unique-advert-marker-square.2573c9c4.svg";